import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F924 {
  f924_01: string;        // Trip No (PK)
  f924_11: string;        // Employee code
  f924_12: string | null; // Application date (ISO)
  f924_13: string;        // Agent code
  f924_14: string;        // Reason
  f924_15: string;        // Location
  f924_16: string;        // Remark
  f924_17: number;        // Trip type: 1=domestic, 2=overseas
  f924_21: string | null; // Start date (ISO)
  f924_22: string;        // Start time
  f924_23: string | null; // End date (ISO)
  f924_24: string;        // End time
  f924_30: number;        // Detail count
  f924_31: string;        // Dept code
  f924_72: string;        // Reviewer code
  f924_73: string | null; // Review date
  f924_74: string;        // Review remark
  f924_79: string;        // Approval flag
  f924_80: string;        // Approval status
  f924_81: string;        // Init approver
  f924_82: string | null; // Init approval date
  f924_83: string;        // Init approval remark
  f924_84: string;        // Re-approver
  f924_85: string | null; // Re-approval date
  f924_87: string;        // Final approver
  f924_88: string | null; // Final approval date
  f924_89: string;        // Final approval remark
  f924_91: string;        // Entry person
  f924_92: string | null; // Entry date
  f924_93: string;        // Modify person

  details?: F9241[];
}

export interface F9241 {
  f9241_01: string;        // Trip No (FK)
  f9241_02: number;        // Seq no
  f9241_11: string | null; // Date (ISO)
  f9241_12: string;        // Start time
  f9241_13: string;        // End time
  f9241_14: string;        // Overseas location
  f9241_15: string;        // Target/contact
  f9241_16: string;        // Planned task
  f9241_91: string;        // Entry person
  f9241_92: string | null; // Entry date
  f9241_93: string;        // Modify person
}

export interface CreateRequest {
  master: Partial<F924>;
  details: Partial<F9241>[];
}

export interface ListResponse {
  data: F924[];
  total: number;
  page: number;
  size: number;
}

// ============================================================
// API Client
// ============================================================

export const pw9224Api = {
  async list(page = 1, size = 20): Promise<ListResponse> {
    const res = await apiClient.get('/api/pw9224', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<F924> {
    const res = await apiClient.get(`/api/pw9224/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F924> {
    const res = await apiClient.post('/api/pw9224', data);
    return res.data;
  },

  async update(id: string, data: CreateRequest): Promise<F924> {
    const res = await apiClient.put(`/api/pw9224/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/pw9224/${encodeURIComponent(id)}`);
  },

  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(
        `/api/pw9224/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`
      );
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
